import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import classNames from 'classnames';
import { reduxForm } from 'redux-form';
import { ReportIcon } from '../icons';
import InputRadio from '../input-radio';
import ButtonGroup from '../../components/button-group';
import { HorizontalSeparator } from '../../components/separator';
import withFontClassName from '../../hoc/with-font-class-name';
import withTranslate from '../../hoc/with-translate';
import styles from './report-abuse-form.scss';

export const REASONS = [
  {
    value: '1',
    text: 'report-abuse-form.offensive-content',
  },
  {
    value: '2',
    text: 'report-abuse-form.offensive-media',
  },
  {
    value: '3',
    text: 'report-abuse-form.spam',
  },
];

/* eslint-disable */
export const ReportAbuseForm = ({
  message,
  title,
  fields,
  handleSubmit,
  onCancel,
  onClose,
  titleFontClassName,
  contentFontClassName,
  t,
}) =>
  <div className={classNames(styles.container, 'forum-text-color', contentFontClassName, 'report')}>
    <h3 className={classNames(styles.titleContainer, titleFontClassName)}>
      <ReportIcon className="forum-icon-fill" />
      <span className={styles.title}>
        {title}
      </span>
    </h3>
    <div className={styles.message}>
      {message}
    </div>
    <form className={classNames(styles.form, 'report__form')} onSubmit={handleSubmit}>
      <div className={styles.reasons} role="radiogroup" aria-labelledby={message} tabIndex="0">
        {_.map(REASONS, (reason, key) =>
          <div key={key} className={styles.reason}>
            <div className={styles.radioInput}>
              <InputRadio
                name="reportType"
                onChange={fields.reportType.onChange}
                checked={fields.reportType.value === reason.value}
                value={reason.value}
                text={t(reason.text)}
                tabIndex={key === 0 ? '0' : '-1'}
              />
            </div>
            <HorizontalSeparator className={styles.separator} />
          </div>
        )}
      </div>
      <ButtonGroup
        primaryButtonText={t('report-abuse-form.submit-button')}
        primaryButtonProps={{ type: 'submit' }}
        secondaryButtonText={t('report-abuse-form.cancel-button')}
        secondaryButtonProps={{ onClick: () => onCancel() }}
      />
    </form>
  </div>;
/* eslint-enable */

ReportAbuseForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  fields: PropTypes.object.isRequired,
  titleFontClassName: PropTypes.string.isRequired,
  contentFontClassName: PropTypes.string.isRequired,
  message: PropTypes.string,
  title: PropTypes.string,
};

export default reduxForm({
  form: 'report',
  fields: ['reportType', '_id'],
  initialValues: {
    reportType: REASONS[0].value,
  },
})(withFontClassName(withTranslate(ReportAbuseForm)));



// WEBPACK FOOTER //
// ./app/components/report-abuse-form/report-abuse-form.js